export const queryKeys = {
  logBookList: 'logBookList',
  logBookGrid: 'logBookGrid',
  listPatients: 'patientsList',
  patientInfo: 'patientInfo',
  reportData: 'reportData',
  agentInfo: 'agentInfo',
  getShareToken: 'getShareToken',
  hypoInfo: 'hypoInfo',
  hypoList:'hypoList',
  province :'province',
  dashboard:'dashboard',
  getInvite:'getInvite',
  doctorList:'doctorList'
};